module.exports = __webpack_public_path__ + "static/media/Mobile_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.5c0867f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arq_infra/Mobile_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.png
// module id = 92
// module chunks = 0